module.exports = __webpack_public_path__ + "static/media/bb.26b1f97e.svg";